module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaWQ9Imljb25zIiB2aWV3Qm94PSIwIDAgMzggMjYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlLz48ZyBmaWxsPSIjZmZmIiBpZD0iSWNvbiI+PHBhdGggZD0iTTM2LDRIMkEyLDIsMCwwLDEsMiwwSDM2QTIsMiwwLDAsMSwzNiw0WiIvPjxwYXRoIGQ9Ik0zNiwxNUgyYTIsMiwwLDAsMSwwLTRIMzZBMiwyLDAsMCwxLDM2LDE1WiIvPjxwYXRoIGQ9Ik0zNiwyNkgyYTIsMiwwLDAsMSwwLTRIMzZBMiwyLDAsMCwxLDM2LDI2WiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu.svg
// module id = 429
// module chunks = 0